import React, { useState, useEffect } from "react";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TablePagination from '@mui/material/TablePagination';
import {
  Button,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
  Backdrop
} from "@material-ui/core";
import Spacer from "../../../components/Spacer";
import MainContainer from "../../../components/MainContainer";
import { DeleteOutlineRounded, Add, Edit } from "@material-ui/icons";
import { headerDataMission } from "../../../data/modules/mission-header";
import { AntTab, AntTabs } from "../../../components/ant-tab";
import { Typography, Box } from "@material-ui/core";
import PropTypes from "prop-types";
import MissionService from "../../../services/MissionService";
import ObjectifService from "../../../services/ObjectifService";
import { useParams } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import Message from "../../tools/Message";
import { useContext } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { hasPrivilege } from "../../../utils/privilege";
import { userDetailContext } from "../../../App";
import { useNavigate } from 'react-router-dom';
import ResultatService from "../../../services/ResultatService";
import ContextService from "../../../services/ContextService";
import TacheService from "../../../services/TacheService";
import TDRService from "../../../services/TDRService";
import SearchIcon from '@mui/icons-material/Search';
import LocalisationMisService from "../../../services/LocalisationMisService";
import TableViewIcon from '@mui/icons-material/TableView';
import { utils, writeFile } from 'xlsx';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { convertFromHTML, EditorState, ContentState } from "draft-js";
import { convertToHTML } from 'draft-convert';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "row",
    elevation: 0,
  },
  form: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  labelPosition: {
    float: 'left',
  },
  text: {
    width: 750,
    height: 100,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "16px",
    "& th": {
      backgroundColor: "#1976d2",
      color: "white",
      padding: "12px 8px",
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "13px",
      border: "1px solid #1565c0",
      verticalAlign: "middle",
    },
    "& td": {
      padding: "10px 8px",
      border: "1px solid #ddd",
      textAlign: "center",
      fontSize: "12px",
      verticalAlign: "top",
    },
    "& tr:nth-child(even)": {
      backgroundColor: "#f9f9f9",
    },
    "& tr:hover": {
      backgroundColor: "#e3f2fd",
    },
  },
  objectifCell: {
    maxWidth: "200px",
    wordWrap: "break-word",
    whiteSpace: "normal",
    textAlign: "left",
  },
  tacheCell: {
    textAlign: "left",
    wordWrap: "break-word",
    whiteSpace: "normal",
  },
  resultatList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    textAlign: "left",
    "& li": {
      padding: "4px 0",
      borderBottom: "1px dashed #ccc",
      "&:last-child": {
        borderBottom: "none",
      },
    },
  },
  actionButtons: {
    display: "flex",
    justifyContent: "center",
    gap: "4px",
  },
  dialog: {
    width: "1150px",
    height: "1150px",
    size: "1000px",
    position: "center"
  },
  feedbackDialogPaper: {
    minWidth: '400px',
    minHeight: '200px',
    borderRadius: '12px',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  }
}));

// ============================================================
// CORRECTION : Suppression du <Typography> dans TabPanel
// qui générait un <p> enveloppant les <h1> et provoquait
// l'erreur validateDOMNesting
// ============================================================
function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const bullRed = (
  <Box
    component="span"
    sx={{
      display: "inline-block",
      mx: "5px",
      transform: "scale(0.8)",
      color: "red",
      fontSize: "20px",
    }}
  >
    *
  </Box>
);

// Fonction utilitaire pour formater une date en jj/mm/aaaa
const formatDate = (dateString) => {
  if (!dateString) return "";
  const parts = dateString.split("-");
  if (parts.length === 3) {
    const [year, month, day] = parts;
    return `${day}/${month}/${year}`;
  }

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

function TDRElaborationAdd(props) {
  const navigate = useNavigate();
  const [descriptions, setDescriptions] = useState([{ description_resultat: '' }]);
  const [isValidExpectedresult, setIsValidExpectedresult] = useState(false);
  const classes = useStyles();
  const [opens, setOpens] = React.useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [html, setHtml] = useState("");
  const [editorStateContexte, setEditorStateContexte] = useState(EditorState.createEmpty());
  const [htmlContexte, setHtmlContexte] = useState("");
  const [listeplanning, setListeplanning] = useState([]);
  const [loadingPlanning, setLoadingPlanning] = useState(true);
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: 'Voulez vous vraiment supprimer ?',
  });

  const options = [
    { value: 'Aucun', label: 'Aucun' },
    { value: 'insert', label: 'Ajout' },
    { value: 'modif', label: 'Modification' },
    { value: 'suppression', label: 'Suppression' }
  ];
  const [historiuser, setHistoriuser] = useState([]);
  const [id_to_delete, setId_to_delete] = useState(0);
  const [ouvert, setOuvert] = React.useState(false);
  const [tachesup, setTachesup] = React.useState(false);
  const [dialogue, setDialogue] = React.useState(false);
  const [opentache, setOpentache] = React.useState(false);
  const [isValidContext, setIsValidContext] = useState(false);
  const [isValidGoals, setIsValidGoals] = useState(false);
  const [isValidExpected_result, setIsValidExpected_result] = useState(false);
  const [isValidActivity, setIsValidActivity] = useState(false);
  const params = useParams();
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);
  const tdrId = params.tdrId;
  const [isSoldeEmpty, setisSoldeEmpty] = React.useState(false);
  const mission_planning_id = params.id;
  const user_id = localStorage.getItem('USER');
  const [rows, setRows] = useState([]);
  const [idtdr, setIdtdr] = useState(params.tdrId);
  const [tache, setTache] = useState([]);
  const [id, setId] = useState([]);
  const [idid, setIdid] = useState([]);
  const [attendu, setAttendu] = useState([]);
  const [comments, setComments] = useState([]);
  const [filtre, setFiltre] = useState({
    user_id: '',
    action: { value: 'Aucun', label: 'Aucun' },
    tdr_id: ''
  });
  const [history, setHistory] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [planningid, setPlanningid] = React.useState(
      params.planningid ?? 0
  );


  // Dialogue de feedback unifié
  const [feedbackOpen, setFeedbackOpen] = React.useState(false);
  const [feedbackType, setFeedbackType] = React.useState("success");
  const [feedbackMessage, setFeedbackMessage] = React.useState("");

  const paginatedData = history.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [form, setForm] = useState({
    mission_planning_id: mission_planning_id,
    context: "",
    title: "",
    financement: [],
    objectif_id: "",
    description_objectif: "",
    commentaire_objectif: "",
    type_objectif: "",
    taux_objectif: "",
    echelonne_objectif: "",
    qualitatif_objectif: "",
    chiffre_objectif: "",
    mode_mesure_id: "",
    unite_objectif: "",
    resultat_attendu_id: "",
    description_resultat: [],
    commentaire_resultat: "",
    type_resultat: "",
    taux_resultat: "",
    echelonne_resultat: "",
    qualitatif_resultat: "",
    chiffre_resultat: "",
    unite: "",
    description_tache: "",
    tache_id: "",
    user_id: user_id
  });

  const [value, setValue] = useState(0);
  const [next, setNext] = useState([]);
  const [financement, setFinancement] = useState([]);

  // Fonctions pour le dialogue de feedback
  const showSuccess = (message) => {
    setFeedbackType("success");
    setFeedbackMessage(message);
    setFeedbackOpen(true);
  };

  const showError = (message) => {
    setFeedbackType("error");
    setFeedbackMessage(message);
    setFeedbackOpen(true);
  };

  const handleFeedbackClose = () => {
    setFeedbackOpen(false);
    setFeedbackMessage("");
  };

  const exportToExcel = () => {
    const worksheet = utils.json_to_sheet(history);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    writeFile(workbook, 'history.xlsx');
  };

  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
    const contentState = newEditorState.getCurrentContent();
    const htmlContent = convertToHTML(contentState);
    setHtml(htmlContent);
  };

  const onEditorStateChangecontext = (newEditorState) => {
    setEditorStateContexte(newEditorState);
    const contentState = newEditorState.getCurrentContent();
    const htmlContent = convertToHTML(contentState);
    setHtmlContexte(htmlContent);
  };

  const handleChangeTab = (event, newValue) => {
    // Empêcher le changement de tab sans utiliser les boutons Suivant/Retour
    if (newValue !== value) {
      event.preventDefault();
      return;
    }
    setFiltre({ ...filtre, tdr_id: idtdr });
    if (newValue === 5) {
      TDRService.gethistorie(filtre).then((res) => {
        if (res.status) {
          setHistory(res.data);
          setHistoriuser(res.user);
        }
      }).catch((err) => {
      });
    }
  };

  // Bouton Retour - permet de revenir à l'étape précédente
  const handleChangePrev = (ev) => {
    if (value === 0) {
      setValue(0);
    } else {
      setValue(value - 1);
    }
  };

  // Bouton Suivant - permet de passer à l'étape suivante avec validation
  const handleChangeNext = (ev) => {
    if (value === 1) {
      handleInsertContext();
    } else if (value === 2) {
      if (rows.length === 0) {
        showError('Veuillez ajouter au moins un objectif avant de continuer.');
        return;
      }
      setValue(value + 1);
    } else if (value === 3) {
      setValue(value + 1);
    } else if (value === 4) {
      setValue(4);
    } else {
      setValue(value + 1);
    }
  };

  const [message, setMessage] = React.useState({
    open: false,
    color: 'green',
    messageInfo: ''
  });
  const { open, color, messageInfo } = message;

  const storage = JSON.parse(
    localStorage.getItem("storage")
  );

  const handlefilter = () => {
    TDRService.gethistorie(filtre).then((res) => {
      if (res.status) {
        setHistory(res.data);
        setHistoriuser(res.user);
      } else {
        setHistory([]);
      }
    }).catch((err) => {
    });
  };

  useEffect(() => {
    TDRService.gethistorie(filtre).then((res) => {
      if (res.status) {
        setHistory(res.data);
        setHistoriuser(res.user);
      }
    }).catch((err) => {
    });
  }, [idtdr, filtre]);

  useEffect(() => {
    // Chargement de la liste du planning
    MissionService.detailplanning()
      .then((res) => {
        if (res.status) {
          setListeplanning(res.data);
        }
      })
      .catch((err) => {
      })
      .finally(() => {
        setLoadingPlanning(false);
      });

    LocalisationMisService.getFinancement().then((result) => {
      if (result) {
        setFinancement(result);
      }
    });

    if (idtdr !== undefined) {
      ContextService.getId(idtdr).then((result) => {
        if (result && result.data) {
          setForm(prevForm => ({
            ...prevForm,
            context: result.data.description_context,
            title: result.data.title,
            financement: result.data.financement
          }));
          setHtmlContexte(result.data.description_context);
          const blocksFromHTML = convertFromHTML(result.data.description_context);
          const contentState = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
          setEditorStateContexte(EditorState.createWithContent(contentState));
        }
      }).catch((err) => {
      });

      TacheService.getDetails(idtdr).then((result) => {
        if (result && result.data) {
          setTache(result.data);
        }
      }).catch((err) => {
      });

      ObjectifService.getById(idtdr).then((res) => {
        if (res.status) {
          setRows(res.data);
        }
      }).catch((err) => {
      });

      ResultatService.getById(idtdr).then((res) => {
        if (res.status) {
          setAttendu(res.data);
        }
      }).catch((err) => {
      });

      MissionService.getcomments(idtdr).then((res) => {
        if (res.status) {
          setComments(res.data);
        }
      }).catch((err) => {
      });

      TDRService.autredivers(idtdr).then((res) => {
        if (res.status) {
          const contenu = res.data;
          setHtml(contenu.contenu);
          const blocksFromHTML = convertFromHTML(contenu.contenu);
          const contentState = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
          setEditorState(EditorState.createWithContent(contentState));
        } else {
          setHtml('');
          setEditorState(EditorState.createEmpty());
        }
      }).catch((err) => {
      });

      TDRService.gethistorie(filtre).then((res) => {
        if (res.status) {
          setHistory(res.data);
          setHistoriuser(res.user);
        }
      }).catch((err) => {
      });
    }
  }, []);

  const handleDelete = (id) => (ev) => {
    setId_to_delete(id);
    setOuvert(true);
  };

  const handleDeleteTache = (id) => (ev) => {
    setId_to_delete(id);
    setTachesup(true);
  };

  const handleDeleteResultat = (id) => (ev) => {
    setId_to_delete(id);
    setDialogue(true);
  };

  const handleClickClose = () => {
    setOuvert(false);
    setDialogue(false);
    setTachesup(false);
  };

  function handleClick() {
    if (form.context === '') {
      setIsValidContext(true);
    }
    if (form.goals === '') {
      setIsValidGoals(true);
    }
    if (form.expected_result === '') {
      setIsValidExpected_result(true);
    }
    if (form.activity === '') {
      setIsValidActivity(true);
    }
    if (form.context !== '' && form.goals !== '' && form.expected_result !== '' && form.activity !== '') {
      MissionService.saveTDRMission(form, form.tdr_mission_id).then((result) => {
        if (result.status) {
          showSuccess(result.message);
          navigate("/mission/elaboration_tdr");
        } else {
          showError(result.message);
        }
      })
        .catch((err) => {
          showError('Erreur lors de l\'enregistrement');
        });
    }
  }

  function handleInsertContext() {

    var contexteValue = htmlContexte;

    if (!contexteValue || contexteValue.trim() === '') {
      showError('Veuillez remplir le contexte et justification');
      return;
    }

    // Si c'est du HTML, nettoyer pour la validation
    var texteBrut = contexteValue.replace(/<[^>]*>/g, '').trim();
    if (!texteBrut) {
      showError('Veuillez remplir le contexte et justification');
      return;
    }

    setOpenLoadingSimpleBackdrop(true);
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });

    ContextService.add(form, idtdr, htmlContexte).then((result) => {
      if (result.status) {
        showSuccess(result.message);
        ContextService.getId(idtdr).then((result) => {
          if (result && result.data) {
            setForm(prevForm => ({
              ...prevForm,
              context: result.data.description_context,
              title: result.data.title
            }));
            setHtmlContexte(result.data.description_context);
            const blocksFromHTML = convertFromHTML(result.data.description_context);
            const contentState = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
            setEditorStateContexte(EditorState.createWithContent(contentState));
          }
        }).catch((err) => {
        });
        setValue(2);
      } else {
        showError(result.message);
      }
      setOpenLoadingSimpleBackdrop(false);
    }).catch((err) => {
      showError('Erreur lors de l\'insertion du contexte');
      setOpenLoadingSimpleBackdrop(false);
    });
  }

  function handleStockInsertObjectif() {
    if (!form.description_objectif || form.description_objectif.trim() === '') {
      showError('Veuillez remplir la description de l\'objectif');
      return;
    }

    setOpenLoadingSimpleBackdrop(true);
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
    setForm(prevForm => ({
      ...prevForm,
      description_resultat: descriptions
    }));

    ObjectifService.add(form, idtdr, form.objectif_id, descriptions).then((result) => {
      ObjectifService.getById(idtdr).then((res) => {
        if (result.status) {
          showSuccess(result.message);
          setRows(res.data);
        } else {
          showError(result.message);
        }
        setOpenLoadingSimpleBackdrop(false);
        setOpens(false);
      }).catch((err) => {
        showError('Erreur lors de l\'enregistrement');
        setOpenLoadingSimpleBackdrop(false);
        setOpens(false);
      });
    });

    setForm({
      ...form,
      mission_planning_id: mission_planning_id,
      financement: [],
      description_objectif: "",
      commentaire_objectif: "",
      type_objectif: "choix",
      taux_objectif: "",
      echelonne_objectif: "",
      qualitatif_objectif: "",
      chiffre_objectif: "",
      unite_objectif: "",
      description_resultat: [],
      commentaire_resultat: "",
      type_resultat: "",
      taux_resultat: "",
      echelonne_resultat: "",
      qualitatif_resultat: "",
      chiffre_resultat: "",
      unite: "",
      description_tache: "",
      tache_id: "",
      user_id: user_id
    });
    setDescriptions([{ description_resultat: '' }]);
    setId([]);
    setOpens(false);
  }

  function handleInsertObjectif() {
    setOpenLoadingSimpleBackdrop(true);
    ObjectifService.insertion(mission_planning_id).then((result) => {
      ObjectifService.getById(mission_planning_id).then((res) => {
        if (result.status && res.status) {
          showSuccess(result.message);
          setRows(res.data);
        } else {
          setRows([]);
          showSuccess(result.message);
        }
        setOpenLoadingSimpleBackdrop(false);
        setOuvert(false);
      }).catch((err) => {
        showError('Erreur lors de l\'insertion');
        setOpenLoadingSimpleBackdrop(false);
        setOuvert(false);
      });
    });
    setValue(2);
  }

  function handleStockInsertResultat() {
    setOpenLoadingSimpleBackdrop(true);
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
    ResultatService.add(form, idtdr, form.resultat_attendu_id).then((result) => {
      ResultatService.getById(idtdr).then((res) => {
        if (result.status) {
          showSuccess(result.message);
          setAttendu(res.data);
        } else {
          showError(result.message);
        }
        setOpenLoadingSimpleBackdrop(false);
        setOpens(false);
      }).catch((err) => {
        showError('Erreur lors de l\'enregistrement');
        setOpenLoadingSimpleBackdrop(false);
        setOpens(false);
      });
    });
    setForm({
      mission_planning_id: mission_planning_id,
      context: "",
      title: "",
      description_objectif: "",
      commentaire_objectif: "",
      type_objectif: "choix",
      taux_objectif: "",
      echelonne_objectif: "",
      qualitatif_objectif: "",
      chiffre_objectif: "",
      unite_objectif: "",
      description_resultat: [],
      commentaire_resultat: "",
      type_resultat: "",
      taux_resultat: "",
      echelonne_resultat: "",
      qualitatif_resultat: "",
      chiffre_resultat: "",
      unite: "",
      description_tache: "",
      tache_id: "",
      user_id: user_id
    });
    setIdid([]);
    setOpens(false);
  }

  function handleInsertResultat() {
    setOpenLoadingSimpleBackdrop(true);
    ResultatService.insertion(mission_planning_id).then((result) => {
      ResultatService.getById(mission_planning_id).then((res) => {
        if (result.status && res.status) {
          showSuccess(result.message);
          setAttendu(res.data);
        } else {
          setAttendu([]);
          showSuccess(result.message);
        }
        setOpenLoadingSimpleBackdrop(false);
        setDialogue(false);
      }).catch((err) => {
        showError('Erreur lors de l\'insertion');
        setOpenLoadingSimpleBackdrop(false);
        setDialogue(false);
      });
    });
    setValue(3);
  }

  function handleValider() {
    navigate("/mission/elaboration_tdr");
  }

  function handleInsertTache() {
    if (!form.description_tache || form.description_tache.trim() === '') {
      showError('Veuillez remplir la description de la tâche');
      return;
    }

    setOpenLoadingSimpleBackdrop(true);
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });

    TacheService.add(form, idtdr).then((result) => {
      if (result.status) {
        showSuccess('Ajout tâche réussi avec succès');
        setOpentache(false);
        TacheService.getDetails(idtdr).then((result) => {
          if (result && result.data) {
            setTache(result.data);
          }
        }).catch((err) => {
        });
      } else {
        showError(result.message || 'Erreur lors de l\'ajout de la tâche');
      }
      setOpenLoadingSimpleBackdrop(false);
    }).catch((err) => {
      showError('Erreur lors de l\'insertion de la tâche');
      setOpenLoadingSimpleBackdrop(false);
    });

    setForm({
      ...form,
      mission_planning_id: mission_planning_id,
      description_objectif: "",
      commentaire_objectif: "",
      type_objectif: "choix",
      taux_objectif: "",
      echelonne_objectif: "",
      qualitatif_objectif: "",
      chiffre_objectif: "",
      unite_objectif: "",
      description_resultat: [],
      commentaire_resultat: "",
      type_resultat: "",
      taux_resultat: "",
      echelonne_resultat: "",
      qualitatif_resultat: "",
      chiffre_resultat: "",
      unite: "",
      description_tache: "",
      tache_id: "",
      user_id: user_id
    });
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
    if (name === "type_objectif") {
      setForm({ ...form, 'type_resultat': value, 'type_objectif': value });
    }
  }

  function handleChange_resultat(event) {
    const { name, value } = event.target;
    setForm({ ...form, [name]: value });
  }

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  function handleChangeEchelonne(event) {
    const { name, value } = event.target;
    const newValue = value.replace(" ", ",");
    setForm({ ...form, [name]: newValue });
  }

  function handleChangeBalance(ev) {
    const { name, value } = ev.target;
    const newValue = value.replace(/[^0-9.]/g, '');
    setForm({ ...form, [name]: newValue });
    setisSoldeEmpty(false);
  }

  const handleClickOpen = () => {
    setOpens(true);
  };

  const handleClickOpentache = () => {
    setOpentache(true);
  };

  const handleClosetache = () => {
    setOpentache(false);
  };

  const handleClose = () => {
    setOpens(false);
  };

  const handleEdit = (id) => (ev) => {
    setOpenLoadingSimpleBackdrop(true);
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  };

  const handleFilter = (event, newValue, fieldName) => {
    setFiltre(prevFiltre => ({
      ...prevFiltre,
      [fieldName]: newValue
    }));
  };

  const handleInsertTitle = () => {
    if (!form.title || form.title.trim() === '') {
      showError('Veuillez remplir le titre');
      return;
    }

    if (idtdr !== undefined) {
      TDRService.updateTitle(form, idtdr, planningid).then((result) => {
        if (result && result.data) {
          setIdtdr(result.data);
          setFiltre({ ...filtre, tdr_id: result.data });
          showSuccess('Titre enregistré avec succès');
          setValue(1);
        }
      }).catch((err) => {
        showError('Erreur lors de l\'enregistrement du titre');
      });
    } else {
      TDRService.AddTitle(form, planningid).then((result) => {
        if (result && result.data) {
          setIdtdr(result.data);
          showSuccess('Titre enregistré avec succès');
          setValue(1);
        }
      }).catch((err) => {
        showError('Erreur lors de l\'enregistrement du titre');
      });
    }
  };

  const handlePlanningChange = (event, newValue) => {
       setPlanningid(newValue?.mission_planning_id ?? null);
  }

  const handleEditObjectif = (id) => (ev) => {
    setOpens(true);
    ObjectifService.getId(id).then((res) => {
      if (res.status) {
        setForm({
          ...form,
          mission_planning_id: mission_planning_id,
          objectif_id: res.data.tdr_objectif_id,
          description_objectif: res.data.description,
          commentaire_objectif: res.data.commentaire,
          type_objectif: res.data.libelle_mode_mesure,
          taux_objectif: res.data.valeur,
          echelonne_objectif: res.data.valeur,
          qualitatif_objectif: res.data.valeur,
          chiffre_objectif: res.data.valeur,
          unite_objectif: res.data.unite,
          mode_mesure_id: res.data.mode_mesure_id,
          resultat_attendu_id: res.data.tdr_ra_id,
          description_resultat: res.data.resultat,
          commentaire_resultat: "",
          type_resultat: res.data.libelle_mode_mesure,
          taux_resultat: res.data.valeur,
          echelonne_resultat: res.data.valeur,
          qualitatif_resultat: res.data.valeur,
          chiffre_resultat: res.data.valeur,
          unite: res.data.unite,
          description_tache: "",
          tache_id: "",
          user_id: user_id
        });
        setDescriptions(res.data.resultat);
        setOpenLoadingSimpleBackdrop(true);
      } else {
        setForm([]);
        setOpenLoadingSimpleBackdrop(false);
      }
    }).catch((err) => {
      showError('Erreur lors du chargement de l\'objectif');
      setOpenLoadingSimpleBackdrop(false);
    });
  };

  const handleChangedes = (e, index) => {
    const { name, value } = e.target;
    const newDescriptions = [...descriptions];
    newDescriptions[index][name] = value;
    setDescriptions(newDescriptions);
  };

  const handleAddDescription = () => {
    setDescriptions([...descriptions, { description_resultat: '' }]);
  };

  const handleEdiTache = (id) => (ev) => {
    setOpentache(true);
    TacheService.getid(id).then((res) => {
      if (res.status) {
        setForm({
          ...form,
          mission_planning_id: mission_planning_id,
          objectif_id: "",
          description_objectif: "",
          commentaire_objectif: "",
          type_objectif: "",
          taux_objectif: "",
          echelonne_objectif: "",
          qualitatif_objectif: "",
          chiffre_objectif: "",
          unite_objectif: "",
          mode_mesure_id: "",
          resultat_attendu_id: "",
          description_resultat: [],
          commentaire_resultat: "",
          type_resultat: "",
          taux_resultat: "",
          echelonne_resultat: "",
          qualitatif_resultat: "",
          chiffre_resultat: "",
          unite: res.data.unite,
          description_tache: res.data.description_tache,
          tache_id: res.data.tache_id,
          user_id: user_id
        });
        setOpenLoadingSimpleBackdrop(true);
      } else {
        setForm([]);
        setOpenLoadingSimpleBackdrop(false);
      }
    }).catch((err) => {
      showError('Erreur lors du chargement de la tâche');
      setOpenLoadingSimpleBackdrop(false);
    });
  };

  const handleChangefinancement = (selectedValues) => {
    setForm({ ...form, financement: selectedValues });
  }

  const handleEditResultat = (id) => (ev) => {
    setOpens(true);
    ResultatService.getId(id).then((res) => {
      if (res.status) {
        setForm({
          mission_planning_id: mission_planning_id,
          context: "",
          objectif_id: "",
          description_objectif: "",
          commentaire_objectif: "",
          type_objectif: "",
          taux_objectif: "",
          echelonne_objectif: "",
          qualitatif_objectif: "",
          chiffre_objectif: "",
          unite_objectif: "",
          mode_mesure_id: res.data.mode_mesure_id,
          resultat_attendu_id: res.data.tdr_ra_id,
          description_resultat: res.data.description,
          commentaire_resultat: res.data.commentaire,
          type_resultat: res.data.libelle_mode_mesure,
          taux_resultat: res.data.libelle_mode_mesure,
          echelonne_resultat: res.data.valeur,
          qualitatif_resultat: res.data.valeur,
          chiffre_resultat: res.data.valeur,
          unite: res.data.unite,
          description_tache: "",
          tache_id: "",
          user_id: user_id
        });
        setOpenLoadingSimpleBackdrop(true);
      } else {
        setForm([]);
        setOpenLoadingSimpleBackdrop(false);
      }
    }).catch((err) => {
      showError('Erreur lors du chargement du résultat');
      setOpenLoadingSimpleBackdrop(false);
    });
  };

  const handleToClose = () => {
    setOuvert(false);
    setOpenLoadingSimpleBackdrop(true);
    ObjectifService.delete(id_to_delete).then((result) => {
      ObjectifService.getById(idtdr).then((res) => {
        if (result.status && res.status) {
          showSuccess(result.message);
          setRows(res.data);
        } else {
          setRows([]);
          showSuccess(result.message);
        }
        setOpenLoadingSimpleBackdrop(false);
        setOuvert(false);
      }).catch((err) => {
        showError('Erreur lors de la suppression');
        setOpenLoadingSimpleBackdrop(false);
        setOuvert(false);
      });
    });
  };

  const handlefinaly = () => {
    if (html === "") {
      navigate('/mission/elaboration_tdr');
    } else {
      TDRService.getdivers(idtdr, html).then((result) => {
        if (result) {
          showSuccess("Enregistrement réussi");
          navigate('/mission/elaboration_tdr');
        } else {
          showError('Insertion échoué');
        }
      })
    }
  }

  const handleToCloseTache = () => {
    TacheService.deletetache(id_to_delete).then((result) => {
      TacheService.getDetails(idtdr).then((result) => {
        if (result && result.data) {
          setTache(result.data);
          setTachesup(false);
          showSuccess("Suppression réussie");
        } else {
          showError('Erreur lors de la suppression');
        }
      })
    });
  }

  const handleToCloseResultat = () => {
    setDialogue(false);
    setOpenLoadingSimpleBackdrop(true);
    ResultatService.delete(id_to_delete).then((result) => {
      ResultatService.getById(idtdr).then((res) => {
        if (result.status && res.status) {
          showSuccess(result.message);
          setAttendu(res.data);
        } else {
          setAttendu([]);
          showSuccess(result.message);
        }
        setOpenLoadingSimpleBackdrop(false);
        setDialogue(false);
      }).catch((err) => {
        showError('Erreur lors de la suppression');
        setOpenLoadingSimpleBackdrop(false);
        setDialogue(false);
      });
    });
  };

  const contextData = useContext(userDetailContext);

  // Affichage d'un loader tant que la liste du planning n'est pas chargée
  if (loadingPlanning) {
    return (
      <MainContainer {...headerDataMission}>
        <Backdrop className={classes.backdrop} open={true}>
          <CircularProgress color="inherit" />
          <Typography variant="h6" style={{ color: '#fff' }}>
            Chargement du planning en cours...
          </Typography>
        </Backdrop>
      </MainContainer>
    );
  }

  return (
    <MainContainer {...headerDataMission}>
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />

      {/* Dialogue de feedback unifié avec style amélioré */}
      <Dialog
        open={feedbackOpen}
        onClose={handleFeedbackClose}
        classes={{ paper: classes.feedbackDialogPaper }}
        PaperProps={{
          style: {
            minWidth: '450px',
            borderRadius: '16px',
            padding: '8px'
          }
        }}
      >
        <DialogTitle style={{
          backgroundColor: feedbackType === "success" ? "#4caf50" : "#f44336",
          color: "white",
          fontSize: "1.5rem",
          fontWeight: "bold",
          textAlign: "center",
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px"
        }}>
          {feedbackType === "success" ? "✅ Succès" : "❌ Erreur"}
        </DialogTitle>

        <DialogContent style={{ padding: "24px" }}>
          <Box sx={{
            mb: 2,
            p: 2,
            bgcolor: '#e3f2fd',
            borderRadius: '12px',
            border: '1px solid #90caf9'
          }}>
            <Typography variant="body2" style={{ color: '#1976d2', fontWeight: 500 }}>
              💡 <strong>Note de navigation :</strong>
            </Typography>
            <Typography variant="body2" style={{ color: '#0d47a1', marginTop: '4px' }}>
              • Cliquez sur <strong>"Enregistrer et continuer →"</strong> pour passer à l'onglet suivant
            </Typography>
            <Typography variant="body2" style={{ color: '#0d47a1' }}>
              • Cliquez sur <strong>"← Retour"</strong> pour revenir à l'onglet précédent
            </Typography>
            <Typography variant="body2" style={{ color: '#0d47a1', marginTop: '4px', fontStyle: 'italic' }}>
              ⚠️ La navigation entre les onglets se fait uniquement via ces boutons
            </Typography>
          </Box>

          <Alert
            severity={feedbackType}
            style={{
              fontSize: "1.1rem",
              alignItems: "center",
              padding: "16px",
              marginTop: "8px"
            }}
          >
            {feedbackMessage}
          </Alert>
        </DialogContent>

        <DialogActions style={{ padding: "16px 24px", justifyContent: "center" }}>
          <Button
            onClick={handleFeedbackClose}
            variant="contained"
            color={feedbackType === "success" ? "primary" : "secondary"}
            style={{
              fontWeight: 600,
              padding: "8px 32px",
              borderRadius: "8px"
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Spacer y={2} />
      <Paper className={classes.root}>
        <AntTabs
          value={value}
          onChange={handleChangeTab}
          indicatorColor="primary"
          textColor="primary"
        >
          <AntTab label="1. Titre" />
          <AntTab label="2. Contexte et justification" disabled={idtdr === undefined} />
          <AntTab label="3. Objectifs et résultats attendus" disabled={idtdr === undefined} />
          <AntTab label="4. Tâches" disabled={idtdr === undefined} />
          <AntTab label="5. Autres et divers" disabled={idtdr === undefined} />
          <AntTab label="6. Historique" disabled={idtdr === undefined} />
        </AntTabs>

        <TabPanel value={value} index={0}>
          <Grid container spacing={1} className={classes.paper}>
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                    <Typography variant="body2" color="textSecondary">
                      📝 Étape 1/6 : Renseignez le titre du document
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <label className={classes.labelPosition}>Planning mission :</label>
                </Grid>
                <Grid item xs={9}>
                  <Autocomplete
                    value={listeplanning.find((p) => p.mission_planning_id === planningid) || null}
                    onChange={handlePlanningChange}
                    options={listeplanning}
                    isOptionEqualToValue={(option, value) =>
                      Number(option.mission_planning_id) === Number(value.mission_planning_id)
                    }
                    getOptionLabel={(option) =>
                      option ? `${option.reference} - ${option.mission_title}` : ""
                    }
                    renderOption={(option) => (
                      <Box sx={{ display: "flex", flexDirection: "column", py: 0.5 }}>
                        <Typography variant="body2" style={{ fontWeight: 600, color: "#1976d2" }}>
                          {option.reference}
                        </Typography>
                        <Typography variant="body2" style={{ color: "#333" }}>
                          {option.mission_title}
                        </Typography>
                        <Typography variant="caption" style={{ color: "#777" }}>
                          📅 Du {formatDate(option.date_begin)} au {formatDate(option.date_fin)}
                        </Typography>
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        label="Planning mission"
                        size="small"
                        variant="outlined"
                        required
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <label className={classes.labelPosition}>Intitulé {bullRed} :</label>
                </Grid>
                <Grid item xs={9}>
                  <TextField multiline className={classes.text} width="auto"
                    id="outlined-basic" size="small" value={form.title}
                    label=""
                    variant="outlined" name="title" onChange={handleChange} />
                </Grid>
                <Grid container item xs={12} justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleInsertTitle}
                    style={{ fontWeight: 600, marginRight: '30px' }}>
                    Enregistrer et continuer →
                  </Button>
                </Grid>
              </Grid>
              <br />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={1}>
          <Grid container spacing={3} className={classes.paper}>
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                    <Typography variant="body2" color="textSecondary">
                      📌 Étape 2/6 : Décrivez le contexte et la justification de la mission
                    </Typography>
                  </Box>
                </Grid>
                {comments.length > 0 &&
                  <Grid item xs={12}>
                    <Box sx={{ p: 1, border: '1px dashed grey', color: 'red', marginBottom: '20px' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <h3 style={{ color: 'black', textDecoration: 'underline', margin: 0 }}>Commentaires sur le contexte et justification : </h3>
                        <h3 style={{ color: 'red', marginLeft: '10px', margin: 0 }}>
                          {
                            (() => {
                              const target = comments.find(comment => comment.field_label === 'Context');
                              return target ? target.observation : 'Non trouvé';
                            })()
                          }
                        </h3>
                      </Box>
                    </Box>
                  </Grid>
                }
                <Grid item xs={3}>
                  <label className={classes.labelPosition}>Contexte et justification {bullRed}</label>
                </Grid>
                <Grid item xs={12}>
                  <div style={{
                    border: '1px solid black',
                    padding: '10px',
                    borderRadius: '4px',
                    minHeight: '550px',
                    height: 'auto'
                  }}>
                    <Editor
                      editorState={editorStateContexte}
                      onEditorStateChange={onEditorStateChangecontext}
                      wrapperClassName="demo-wrapper"
                      editorClassName="demo-editor"
                      toolbar={{
                        options: ["inline", "blockType", "fontSize", "list", "textAlign", "colorPicker"],
                        inline: {
                          inDropdown: false,
                          options: ["bold", "italic", "underline"],
                        },
                      }}
                    />
                  </div>
                </Grid>
                <Grid container item xs={12} justifyContent="flex-end">
                  <Button
                    name="prev"
                    value={value}
                    color="secondary"
                    variant="outlined"
                    style={{ marginRight: "30px" }}
                    onClick={handleChangePrev}>
                    ← Retour
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleChangeNext}
                    style={{ marginRight: "30px" }}>
                    Enregistrer et continuer →
                  </Button>
                </Grid>
              </Grid>
              <br />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={2}>
          <Grid container spacing={3} className={classes.paper}>
            <Grid item xs={12}>
              <fieldset>
                <legend>Objectifs et résultats attendus</legend>
                <br />
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                      <Typography variant="body2" color="textSecondary">
                        🎯 Étape 3/6 : Définissez les objectifs et les résultats attendus
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    {/* CORRECTION : remplacement de <h1> par un <div> pour éviter
                        le warning validateDOMNesting (h1 dans p) */}
                    <div style={{ marginBottom: "24px" }}>
                      <Button variant="outlined" color="primary" title="Ajout d'observation" onClick={handleClickOpen}>
                        <Add style={{ color: "green" }} /> Ajouter objectifs et résultats
                      </Button>
                    </div>
                    {comments.length > 0 &&
                      <>
                        <Grid item xs={12}>
                          <Box sx={{ p: 1, border: '1px dashed grey', color: 'red', marginBottom: '20px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <h3 style={{ color: 'black', textDecoration: 'underline', margin: 0 }}>Commentaires sur les objectifs : </h3>
                              <h3 style={{ color: 'red', marginLeft: '10px', margin: 0 }}>
                                {
                                  (() => {
                                    const target = comments.find(comment => comment.field_label === 'Objectifs');
                                    return target ? target.observation : 'Non trouvé';
                                  })()
                                }
                              </h3>
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box sx={{ p: 1, border: '1px dashed grey', color: 'red', marginBottom: '20px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <h3 style={{ color: 'black', textDecoration: 'underline', margin: 0 }}>Commentaires sur les résultats attendus : </h3>
                              <h3 style={{ color: 'red', marginLeft: '10px', margin: 0 }}>
                                {
                                  (() => {
                                    const target = comments.find(comment => comment.field_label === 'Resulat attendus');
                                    return target ? target.observation : 'Non trouvé';
                                  })()
                                }
                              </h3>
                            </Box>
                          </Box>
                        </Grid>
                      </>
                    }
                    <Grid item xs={12} style={{ overflowX: "auto", marginTop: "24px" }}>
                      <table className={classes.table}>
                        <thead>
                          <tr>
                            <th style={{ width: "18%" }}>Objectifs</th>
                            <th style={{ width: "10%" }}>Mode de mesure</th>
                            <th style={{ width: "8%" }}>Valeur</th>
                            <th style={{ width: "8%" }}>Unité</th>
                            <th style={{ width: "18%" }}>Résultats attendus</th>
                            <th style={{ width: "10%" }}>Mode de mesure</th>
                            <th style={{ width: "8%" }}>Valeur</th>
                            <th style={{ width: "8%" }}>Unité</th>
                            <th style={{ width: "12%" }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.length === 0 ? (
                            <tr>
                              <td colSpan="9" style={{ textAlign: "center", padding: "20px", color: "#777", fontStyle: "italic" }}>
                                Aucun objectif enregistré. Cliquez sur "Ajouter objectifs et résultats" pour commencer.
                              </td>
                            </tr>
                          ) : (
                            rows.map((row) => (
                              <tr key={row.tdr_objectif_id}>
                                <td className={classes.objectifCell}>{row.description}</td>
                                <td>{row.libelle_mode_mesure}</td>
                                <td>{row.valeur}</td>
                                <td>{row.unite}</td>
                                <td>
                                  {row.resultat && row.resultat.length > 0 ? (
                                    <ul className={classes.resultatList}>
                                      {row.resultat.map((ts, index) => (
                                        <li key={index}>{ts.resultat_description}</li>
                                      ))}
                                    </ul>
                                  ) : (
                                    <span style={{ color: "#999", fontStyle: "italic" }}>—</span>
                                  )}
                                </td>
                                <td>
                                  {row.resultat && row.resultat.length > 0 ? (
                                    <ul className={classes.resultatList}>
                                      {row.resultat.map((ts, index) => (
                                        <li key={index}>{ts.libelle_mode_mesure_resultat}</li>
                                      ))}
                                    </ul>
                                  ) : (
                                    <span style={{ color: "#999", fontStyle: "italic" }}>—</span>
                                  )}
                                </td>
                                <td>
                                  {row.resultat && row.resultat.length > 0 ? (
                                    <ul className={classes.resultatList}>
                                      {row.resultat.map((ts, index) => (
                                        <li key={index}>{ts.valeur_resultat}</li>
                                      ))}
                                    </ul>
                                  ) : (
                                    <span style={{ color: "#999", fontStyle: "italic" }}>—</span>
                                  )}
                                </td>
                                <td>
                                  {row.resultat && row.resultat.length > 0 ? (
                                    <ul className={classes.resultatList}>
                                      {row.resultat.map((ts, index) => (
                                        <li key={index}>{ts.unite_resultat}</li>
                                      ))}
                                    </ul>
                                  ) : (
                                    <span style={{ color: "#999", fontStyle: "italic" }}>—</span>
                                  )}
                                </td>
                                <td>
                                  <div className={classes.actionButtons}>
                                    <Button
                                      title="Modifier l'objectif"
                                      onClick={handleEditObjectif(row.tdr_objectif_id)}
                                      size="small"
                                    >
                                      <Edit style={{ color: "#1976d2", fontSize: "20px" }} />
                                    </Button>
                                    <Button
                                      title="Supprimer l'objectif"
                                      onClick={handleDelete(row.tdr_objectif_id)}
                                      size="small"
                                    >
                                      <DeleteOutlineRounded style={{ color: "#d32f2f", fontSize: "20px" }} />
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </Grid>
                  </Grid>

                  <Dialog open={ouvert} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                    <DialogContent>
                      <DialogContentText>
                        voulez-vous vraiment supprimer ?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleClickClose} variant="contained" color="secondary">
                        Annuler
                      </Button>
                      <Button onClick={handleToClose} variant="contained" color="primary">
                        valider
                      </Button>
                    </DialogActions>
                  </Dialog>

                  <Dialog
                    fullWidth={true}
                    maxWidth="lg"
                    style={{ maxHeight: '100vh' }}
                    open={opens}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Objectifs et résultats attendus
                    </DialogTitle>
                    <DialogContent sx={{ height: "40vh" }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <span style={{
                            color: 'green',
                            fontWeight: 'bold',
                            marginLeft: '8px'
                          }}>
                            ✓ Merci d'ajouter un seul objectif sans ponctuation le système crée automatiquement une liste par la suite
                          </span>
                        </Grid>
                        <Grid item xs={3}>
                          <label className={classes.labelPosition}>Description de l'objectif {bullRed}</label>
                        </Grid>
                        <Grid item xs={9}>
                          <TextField multiline className={classes.text} width="auto" rows={3} rowsMax={5}
                            id="outlined-basic" size="small" label="" variant="outlined"
                            value={form.description_objectif} name="description_objectif" onChange={handleChange} />
                          {isValidGoals && <Alert severity="error">Veuillez remplir ce champ</Alert>}
                        </Grid>

                        <Grid item xs={3}>
                          <label className={classes.labelPosition}>Mode mesure de l'objectif {bullRed}</label>
                        </Grid>
                        <Grid item xs={9}>
                          <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="demo-simple-select-outlined-label">Type</InputLabel>
                            <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" label="" name="type_objectif"
                              value={form.type_objectif} onChange={handleChange}>
                              <MenuItem value="Narratif">Narratif</MenuItem>
                              <MenuItem value="taux">Taux</MenuItem>
                              <MenuItem value="echélonné">Echélonné</MenuItem>
                              <MenuItem value="chiffre">Chiffre</MenuItem>
                            </Select>
                          </FormControl>
                          {isValidGoals && <Alert severity="error">Veuillez remplir ce champ</Alert>}
                        </Grid>

                        {form.type_objectif === "taux" && (
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item xs={3}>
                                <label className={classes.labelPosition}>Taux {bullRed}</label>
                              </Grid>
                              <Grid item xs={9}>
                                <TextField multiline className={classes.text} width="auto" rows={1} rowsMax={5} id="outlined-basic"
                                  size="small" value="100" variant="outlined" name="taux_objectif" onChange={handleChange} />
                                {isValidGoals && <Alert severity="error">Veuillez remplir ce champ</Alert>}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {form.type_objectif === "echélonné" && (
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item xs={3}>
                                <label className={classes.labelPosition}>Echélonné {bullRed}</label>
                              </Grid>
                              <Grid item xs={9}>
                                <TextField multiline className={classes.text} width="auto" rows={3} rowsMax={5}
                                  id="outlined-basic" size="small" label="mot séparé par une virgule" value={form.echelonne_objectif} variant="outlined"
                                  name="echelonne_objectif" onChange={handleChangeEchelonne} />
                                {isValidGoals && <Alert severity="error">Veuillez remplir ce champ</Alert>}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {form.type_objectif === "chiffre" && (
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item xs={3}>
                                <label className={classes.labelPosition}>Chiffre {bullRed}</label>
                              </Grid>
                              <Grid item xs={9}>
                                <TextField
                                  fullWidth
                                  className={classes.text}
                                  error={isSoldeEmpty}
                                  id="outlined-basic"
                                  size="small"
                                  label="Seulement des chiffres"
                                  variant="outlined"
                                  value={form.chiffre_objectif}
                                  name="chiffre_objectif"
                                  onChange={handleChangeBalance}
                                />
                                {isValidGoals && <Alert severity="error">Veuillez remplir ce champ</Alert>}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {(form.type_objectif === "chiffre" || form.type_objectif === "taux") && (
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item xs={3}>
                                <label className={classes.labelPosition}>Unité</label>
                              </Grid>
                              <Grid item xs={9}>
                                <TextField multiline className={classes.text} width="auto" rows={3} rowsMax={5}
                                  id="outlined-basic" size="small" value={form.type_objectif === "taux" ? "%" : form.unite_objectif}
                                  label="Unité" variant="outlined"
                                  name="unite_objectif" onChange={handleChange} />
                                {isValidGoals && <Alert severity="error">Veuillez remplir ce champ</Alert>}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        <Grid item xs={4}>
                          <label className={classes.labelPosition}>Description du résultat attendu {bullRed}</label>
                        </Grid>
                        {descriptions.map((desc, index) => (
                          <Grid item xs={12} key={index}>
                            <Grid container spacing={2}>
                              <Grid item xs={3}></Grid>
                              <Grid item xs={9}>
                                <TextField
                                  multiline
                                  className={classes.text}
                                  rows={3}
                                  rowsMax={5}
                                  id={`description-${index}`}
                                  size="small"
                                  label={`Résultat attendu ${index + 1}`}
                                  variant="outlined"
                                  value={desc.description_resultat}
                                  name="description_resultat"
                                  onChange={(e) => handleChangedes(e, index)}
                                />
                                {isValidExpected_result && <Alert severity="error">Veuillez remplir ce champ</Alert>}
                              </Grid>
                            </Grid>
                          </Grid>
                        ))}
                        <Grid item xs={12} className={classes.addButton}>
                          <Button variant="outlined" color="primary" onClick={handleAddDescription}>
                            Autre résultat
                          </Button>
                        </Grid>

                        <Grid item xs={4}>
                          <label className={classes.labelPosition}>Mode mesure du résultat attendu {bullRed}</label>
                        </Grid>
                        <Grid item xs={9}>
                          <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="demo-simple-select-outlined-label">Type</InputLabel>
                            <Select labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined"
                              label="" name="type_resultat" value={form.type_resultat} onChange={handleChange_resultat}>
                              <MenuItem value="Narratif">Narratif</MenuItem>
                              <MenuItem value="taux">Taux</MenuItem>
                              <MenuItem value="echélonné">Echélonné</MenuItem>
                              <MenuItem value="chiffre">Chiffre</MenuItem>
                            </Select>
                          </FormControl>
                          {isValidGoals && <Alert severity="error">Veuillez remplir ce champ</Alert>}
                        </Grid>

                        {form.type_resultat === "taux" && (
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item xs={3}>
                                <label className={classes.labelPosition}>Taux {bullRed}</label>
                              </Grid>
                              <Grid item xs={9}>
                                <TextField multiline className={classes.text} width="auto" rows={1} rowsMax={5} id="outlined-basic" size="small" value={100}
                                  variant="outlined" name="taux_resultat" onChange={handleChange} />
                                {isValidGoals && <Alert severity="error">Veuillez remplir ce champ</Alert>}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {form.type_resultat === "echélonné" && (
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item xs={3}>
                                <label className={classes.labelPosition}>Echélonné {bullRed}</label>
                              </Grid>
                              <Grid item xs={9}>
                                <TextField multiline className={classes.text} width="auto" rows={3} rowsMax={5} id="outlined-basic" size="small"
                                  label="mot séparé par une virgule" variant="outlined"
                                  value={form.echelonne_resultat} name="echelonne_resultat" onChange={handleChangeEchelonne} />
                                {isValidGoals && <Alert severity="error">Veuillez remplir ce champ</Alert>}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {form.type_resultat === "chiffre" && (
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item xs={3}>
                                <label className={classes.labelPosition}>Chiffre {bullRed}</label>
                              </Grid>
                              <Grid item xs={9}>
                                <TextField
                                  fullWidth
                                  error={isSoldeEmpty}
                                  id="outlined-basic"
                                  size="small"
                                  label="Seulement des chiffres"
                                  variant="outlined"
                                  value={form.chiffre_resultat}
                                  name="chiffre_resultat"
                                  onChange={handleChangeBalance}
                                />
                                {isValidGoals && <Alert severity="error">Veuillez remplir ce champ</Alert>}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {(form.type_resultat === "chiffre" || form.type_resultat === "taux") && (
                          <Grid item xs={12}>
                            <Grid container spacing={2}>
                              <Grid item xs={3}>
                                <label className={classes.labelPosition}>Unité {bullRed}</label>
                              </Grid>
                              <Grid item xs={9}>
                                <TextField multiline className={classes.text} width="auto" rows={3} rowsMax={5} id="outlined-basic" size="small" label="Résultat attendus"
                                  variant="outlined" name="unite" value={form.type_resultat === "taux" ? "%" : form.unite} onChange={handleChange} />
                                {isValidExpected_result && <Alert severity="error">Veuillez remplir ce champ</Alert>}
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </DialogContent>
                    <DialogActions>
                      <Button color="primary" variant="contained" onClick={handleStockInsertObjectif}>Enregistrer</Button>
                      <Button onClick={handleClose} variant="contained" color="secondary" autoFocus>
                        Annuler
                      </Button>
                    </DialogActions>
                  </Dialog>

                  <Grid container item xs={12} justifyContent="flex-end">
                    <Button
                      name="prev"
                      value={value}
                      color="secondary"
                      variant="outlined"
                      style={{ marginRight: "30px" }}
                      onClick={handleChangePrev}>
                      ← Retour
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleChangeNext}
                      style={{ marginRight: "30px" }}>
                      Suivant →
                    </Button>
                  </Grid>
                </Grid>
                <br />
              </fieldset>
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={3}>
          <Grid container spacing={3} className={classes.paper}>
            <Grid item xs={12}>
              <fieldset>
                <legend>Tâche à faire</legend>
                <br />
                <Grid item xs={12}>
                  <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                    <Typography variant="body2" color="textSecondary">
                      ✅ Étape 4/6 : Listez les tâches à réaliser
                    </Typography>
                  </Box>
                  {/* CORRECTION : remplacement de <h1> par un <div> pour éviter
                      le warning validateDOMNesting (h1 dans p) */}
                  <div style={{ marginBottom: "24px" }}>
                    <Button title="Ajout tâche" variant="outlined" color="primary" onClick={handleClickOpentache}>
                      <Add style={{ color: "green" }} /> Ajouter tâche
                    </Button>
                  </div>
                  {comments.length > 0 &&
                    <Grid item xs={12}>
                      <Box sx={{ p: 1, border: '1px dashed grey', color: 'red', marginBottom: '20px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <h3 style={{ color: 'black', textDecoration: 'underline', margin: 0 }}>Commentaires sur les tâches : </h3>
                          <h3 style={{ color: 'red', marginLeft: '10px', margin: 0 }}>
                            {
                              (() => {
                                const target = comments.find(comment => comment.field_label === 'Tâche');
                                return target ? target.observation : 'Non trouvé';
                              })()
                            }
                          </h3>
                        </Box>
                      </Box>
                    </Grid>
                  }
                  <Dialog
                    fullWidth={true}
                    maxWidth="lg"
                    open={opentache}
                    onClose={handleClosetache}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Tâche
                    </DialogTitle>
                    <DialogContent sx={{ height: "20vh" }}>
                      <Grid item xs={12}>
                        <span style={{
                          color: 'green',
                          fontWeight: 'bold',
                          marginLeft: '8px'
                        }}>
                          ✓ Merci d'ajouter un seul tâche sans ponctuation le système crée automatiquement une liste par la suite
                        </span>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={3}>
                          <label className={classes.labelPosition}>Description {bullRed}</label>
                        </Grid>
                        <Grid item xs={9}>
                          <TextField multiline className={classes.text} width="auto" rows={3} rowsMax={5}
                            id="outlined-basic" size="small" label="" variant="outlined"
                            value={form.description_tache} name="description_tache" onChange={handleChange} />
                        </Grid>
                      </Grid>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleInsertTache} variant="contained" color="primary">Enregistrer</Button>
                      <Button onClick={handleClosetache} variant="contained" color="secondary" autoFocus>
                        Annuler
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Grid>
                <Grid item xs={12} style={{ overflowX: "auto", marginTop: "24px" }}>
                  <table className={classes.table}>
                    <thead>
                      <tr>
                        <th style={{ width: "5%" }}>N°</th>
                        <th style={{ width: "75%" }}>Description de la tâche</th>
                        <th style={{ width: "20%" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tache.length === 0 ? (
                        <tr>
                          <td colSpan="3" style={{ textAlign: "center", padding: "20px", color: "#777", fontStyle: "italic" }}>
                            Aucune tâche enregistrée. Cliquez sur "Ajouter tâche" pour commencer.
                          </td>
                        </tr>
                      ) : (
                        tache.map((row, index) => (
                          <tr key={row.tache_id}>
                            <td style={{ fontWeight: "bold", color: "#1976d2" }}>{index + 1}</td>
                            <td className={classes.tacheCell}>{row.description_tache}</td>
                            <td>
                              <div className={classes.actionButtons}>
                                <Button
                                  title="Modifier la tâche"
                                  onClick={handleEdiTache(row.tache_id)}
                                  size="small"
                                >
                                  <Edit style={{ color: "#1976d2", fontSize: "20px" }} />
                                </Button>
                                <Button
                                  title="Supprimer la tâche"
                                  onClick={handleDeleteTache(row.tache_id)}
                                  size="small"
                                >
                                  <DeleteOutlineRounded style={{ color: "#d32f2f", fontSize: "20px" }} />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </Grid>
                <Grid container item xs={12} justifyContent="flex-end" style={{ marginTop: "24px" }}>
                  <Button
                    name="prev"
                    variant="outlined"
                    value={value}
                    color="secondary"
                    style={{ marginRight: "30px" }}
                    onClick={handleChangePrev}>
                    ← Retour
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleChangeNext}
                    style={{ marginRight: "30px" }}>
                    Suivant →
                  </Button>
                </Grid>
                <br />
              </fieldset>
              <Dialog open={tachesup} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogContent>
                  <DialogContentText>
                    voulez-vous vraiment supprimer ?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClickClose} variant="contained" color="secondary">
                    Annuler
                  </Button>
                  <Button onClick={handleToCloseTache} variant="contained" color="primary">
                    valider
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={4}>
          <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
            <Typography variant="body2" color="textSecondary">
              📝 Étape 5/6 : Ajoutez d'autres informations complémentaires
            </Typography>
          </Box>
          <div style={{
            border: '1px solid black',
            padding: '10px',
            borderRadius: '4px',
            height: '400px'
          }}>
            <Editor
              editorState={editorState}
              onEditorStateChange={onEditorStateChange}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor"
              toolbar={{
                options: ["inline", "blockType", "fontSize", "list", "textAlign", "colorPicker"],
                inline: {
                  inDropdown: false,
                  options: ["bold", "italic", "underline"],
                },
              }}
            />
          </div>
          <Grid container spacing={3} className={classes.paper}>
            <Grid item xs={10}>
            </Grid>
            <Grid item xs={2}>
              <Button
                onClick={handlefinaly}
                variant="contained" color="primary">
                Valider et terminer
              </Button>
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={5}>
          <Grid container spacing={3} className={classes.paper}>
            <Grid item xs={12}>
              <Box sx={{ mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
                <Typography variant="body2" color="textSecondary">
                  📊 Étape 6/6 : Consultez l'historique des modifications
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                id="demo-select-small"
                options={options}
                value={filtre.action}
                onChange={(event, newValue) => handleFilter(event, newValue, 'action')}
                getOptionLabel={(option) => option.label}
                size="small"
                style={{ margin: "10px" }}
                renderInput={(params) => <TextField {...params} label="Sélectionnez une action" variant="outlined" size="small" />}
              />
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                id="demo-select-small"
                options={historiuser}
                value={filtre.user_id}
                onChange={(event, newValue) => handleFilter(event, newValue, 'user_id')}
                getOptionLabel={(option) => option.utilisateur}
                size="small"
                name="user_id"
                style={{ margin: "10px" }}
                renderInput={(params) => <TextField {...params} label="Utilisateur" variant="outlined" size="small" />}
              />
            </Grid>
            <Grid item xs={1.5}>
              <Button
                variant="contained"
                color="primary"
                onClick={handlefilter}
                style={{ fontWeight: 600, marginTop: "10px", width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <SearchIcon style={{ marginRight: '8px' }} />
                Filtrer
              </Button>
            </Grid>
            <Grid item xs={1.5}>
              <Button
                variant="contained"
                color="primary"
                onClick={exportToExcel}
                style={{ fontWeight: 600, marginTop: "10px", width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <TableViewIcon style={{ marginRight: '8px' }} />
                Export Excel
              </Button>
            </Grid>
            <Grid item xs={0.5}> </Grid>
            <Grid item xs={12}>
              <p style={{ textAlign: 'center' }}>Liste des historiques</p>
            </Grid>
            <Grid item xs={12}>
              <table className={classes.table} style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Nouvelle version</th>
                    <th>Ancienne version</th>
                    <th>Action</th>
                    <th>Utilisateur</th>
                    <th>Date et heure</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((ts, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid black', fontSize: "10px" }}>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: "10px" }}>
                        {
                          ts.type === "context" ? "Contexte et justification" :
                            ts.type === "tache" ? "Tâche" :
                              ts.type === "resultat" ? "Résultat attendu" :
                                "Objectifs"
                        }
                      </td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: "10px" }}>{ts.newvaleur}</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: "10px" }}>{ts.oldvaleur}</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: "10px" }}>
                        {
                          ts.action === "insert" ? "Ajout" :
                            ts.action === "modif" ? "Modification" :
                              "Suppression"
                        }
                      </td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: "10px" }}>{ts.utilisateur}</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: "10px" }}>
                        {ts.date} {ts.formatted_time}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <TablePagination
                component="div"
                count={history.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
                labelRowsPerPage="Lignes par page"
              />
            </Grid>
          </Grid>
        </TabPanel>
      </Paper>
    </MainContainer>
  );
}

export default TDRElaborationAdd;